import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageSidebar } from 'monica-alexandria';
import { Toolbar_ } from '../../partials/navigation/Toolbar_';
import Legacy_Board from '../../partials/offersBoard/Legacy_Board';
import { get_route_language } from '../../../helpers/routeLanguage';

export default function LEGACY_OFFERS() {
    const { t, i18n } = useTranslation();
    const [sidebar, setSidebar] = useState(false);
    const routeLanguage = get_route_language(i18n.language);

    return (
        <PageSidebar>
            <Toolbar_
                sidebar={sidebar}
                onSidebar={() => setSidebar(!sidebar)}
                routeLanguage={routeLanguage}
                activeOption="legacy"
            />
            <Legacy_Board
                title={t('Legacy Offers')}
                routeLanguage={routeLanguage}
            />
        </PageSidebar>
    );
}
